// src/constants/routes.js
// Toutes les routes de Fynho - NE PAS MODIFIER

const ROUTES = {
    // Routes publiques
    HOME: '/',
    SEARCH: '/search',
    MAP_SEARCH: '/map',
    LISTING_DETAIL: '/listing/:slug',
    SEJOURS: '/sejours',
    LOCATIONS: '/locations',
    IMMOBILIER: '/immobilier',
    SERVICES: '/services',
    FAVORITES: '/favorites',
    RESERVATIONS: '/reservations',
  
    // Routes auth (optionnelles)
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
  
    // Routes utilisateur connecté
    PROFILE: '/profile',
    NOTIFICATIONS: '/notifications',
    MESSAGES: '/messages',
    SETTINGS: '/settings',
    SUPPORT: '/support',
  
    // Routes propriétaire
    OWNER_DASHBOARD: '/owner/dashboard',
    OWNER_RESERVATIONS: '/owner/reservations',
  
    // Routes admin
    ADMIN_LOGIN: '/admin/login',
    ADMIN_DASHBOARD: '/admin/dashboard',
    ADMIN_LISTINGS: '/admin/listings',
    ADMIN_ADD_LISTING: '/admin/listings/add',
    ADMIN_EDIT_LISTING: '/admin/listings/edit/:id',
    ADMIN_RESERVATIONS: '/admin/reservations',
    ADMIN_OWNERS: '/admin/owners',
    ADMIN_QUARTIERS: '/admin/quartiers',
    ADMIN_TYPES: '/admin/types',
    ADMIN_USERS: '/admin/users',
    ADMIN_ADMINS: '/admin/admins',
    ADMIN_VALIDATION: '/admin/validation',
    ADMIN_REVIEWS: '/admin/reviews',
    ADMIN_REPORTS: '/admin/reports',
    ADMIN_STATS: '/admin/stats',
    ADMIN_AUDIT_LOGS: '/admin/audit-logs',
  };
  
  export default ROUTES;